// extracted by mini-css-extract-plugin
export default {"product-status__tab":"index_product-status__tab__Rxv2b","status-fixed":"index_status-fixed__Sv3sN","item":"index_item__BokSR","active":"index_active__sBaxU"};